'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    skeletonClassNames: function() {
        return skeletonClassNames;
    },
    useSkeletonStyles_unstable: function() {
        return useSkeletonStyles_unstable;
    }
});
const _react = require("@griffel/react");
const skeletonClassNames = {
    root: 'fui-Skeleton'
};
const useStyles = /*#__PURE__*/ (0, _react.__styles)({
    blockStyling: {
        mc9l5x: "ftgm304"
    }
}, {
    d: [
        ".ftgm304{display:block;}"
    ]
});
const useSkeletonStyles_unstable = (state)=>{
    'use no memo';
    const styles = useStyles();
    state.root.className = (0, _react.mergeClasses)(skeletonClassNames.root, state.root.as === 'span' && styles.blockStyling, state.root.className);
    return state;
};
